module.exports = __webpack_public_path__ + "static/media/main.6861f3c2.png";